export default {
  "content": "<title>notice-gray</title><g fill=\"#3F4450\" fill-rule=\"evenodd\"><path d=\"M8 1c1.87 0 3.628.728 4.95 2.05A6.954 6.954 0 0115 8c0 1.87-.728 3.628-2.05 4.95A6.954 6.954 0 018 15a6.954 6.954 0 01-4.95-2.05A6.954 6.954 0 011 8c0-1.87.728-3.628 2.05-4.95A6.954 6.954 0 018 1zm0-1a8 8 0 100 16A8 8 0 008 0z\"/><path d=\"M8.65 11.83h-1.3V8H6.5V6.915h2.15v4.915zm.2-6.803a.797.797 0 01-.252.604.848.848 0 01-.605.24.812.812 0 01-.598-.246.815.815 0 01-.245-.597c0-.244.082-.447.245-.61a.812.812 0 01.598-.247c.236 0 .438.082.605.246a.82.82 0 01.252.61z\"/></g>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};